import React from "react";
import { graphql } from "gatsby";

import Layout from "../../components/Layout";
import NewsletterSignupForm from "../../components/Forms/NewsletterSignupForm";
import ArticleCard from "../../components/ArticleCard";
import WithI18next from "../../components/WithI18next";

const NewsPage = ({ data, t }) => {
  return (
    <Layout title={t("news.seo.title")} description={t("news.seo.description")}>
      <div id="news" className="pt-5">
        <div className="container mb-5 py-5 page-content">
          <h1 className="text-center mb-5">{t("news.title")}</h1>
          <div className="row">
            <div className="col-md-8 offset-md-2 offset-lg-3 mb-5 pb-5 d-flex justify-content-center">
              <NewsletterSignupForm />
            </div>
          </div>
          <div className="row">
            {data.allWpNewsItem.edges.map((post, i) => (
              <div
                className="col-sm-6 col-lg-4 mb-4 d-flex align-items-stretch"
                key={`news-item-${i}`}
              >
                <ArticleCard
                  title={post.node.title}
                  excerpt={post.node.content}
                  date={post.node.date}
                  featuredImageNode={post.node.featuredImage?.node}
                  linkText={
                    <>
                      <span className="has-cyan-bluish-gray-color">
                        {t("news.by")}
                      </span>{" "}
                      {post.node.acfNews.nSource}
                    </>
                  }
                  linkTo={post.node.acfNews.nSourceUrl}
                  footerBorder="border-1"
                  isTextTruncated={false}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default WithI18next()(NewsPage);

export const query = graphql`
  query ($wpGlobalConfig: String!) {
    allWpNewsItem(
      filter: { acfGlobalConfiguration: { gcLinkTo: { eq: $wpGlobalConfig } } }
      sort: { order: DESC, fields: date }
    ) {
      edges {
        node {
          title
          slug
          content
          date(formatString: "MMMM DD, YYYY")
          acfNews {
            nSource
            nSourceUrl
          }
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 450, layout: CONSTRAINED)
                }
              }
            }
          }
        }
      }
    }
  }
`;
